module.exports = __webpack_public_path__ + "static/media/lv.6fe9fbd6.svg";